import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import {
  commonActions,
  ShowRoomDetailsModel,
  allVehicleModelActions,
  AllVehicleStateModel,
  showRoomListActions,
  AppSettingsStateViewModel,
  api,
  AppSettingsLanguageAction,
  AppSettingsHtmlDirectionAction,
} from 'alg-ecom-frontend-core';
import { State } from 'store/interfaces';
import { connect, useDispatch } from 'react-redux';
import { Link, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import ReactModal from 'react-modal';
import FinanceCalculatorPopUp from './popup/FinanceCalculatorPopUp';
import RequestCallbackPopUp from './popup/RequestCallbackPopUp';
import BookTestDrivePopUp from './popup/BookTestDrivePopUp';
import DownloadBrochurePopUp from './popup/DownloadBrochurePopUp';
import ShowRoomVisitPopUp from './popup/ShowRoomVisitPopUp';
import { RouteKeys } from 'containers/routes/route-keys';
import MenuItem from './MenuItem';
import BookServicePopUp from 'containers/build-vehicle/action-footer/BookServicePopUp';
import RequestQuotePopUp from 'containers/build-vehicle/action-footer/RequestQuotePopUp';
import Config from 'config';

export const customStylesPopup: ReactModal.Styles = {
  content: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    maxWidth: '1140px',
    width: '100%',
    border: '0',
    boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.08)',
    padding: '0',
    margin: '20px auto',
  },
  overlay: {
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    overflow: 'auto',
  },
};

export const customStylesWhatsappPopup: ReactModal.Styles = {
  content: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    maxWidth: '571px',
    width: '100%',
    border: '0',
    boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.08)',
    padding: '0',
    margin: '20px auto',
  },
  overlay: {
    zIndex: 100000,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    overflow: 'auto',
  },
};

interface CustomProps {
  isMenuOpen: boolean;
  toggleMenu: typeof commonActions.toggleMenu;
  toggleRequestCallback: typeof commonActions.toggleRequestCallback;
  toggleBookTestDrive: typeof commonActions.toggleBookTestDrive;
  toggleDownloadBrochure: typeof commonActions.toggleDownloadBrochure;
  toggleRequestQuote: typeof commonActions.toggleRequestQuote;
  toggleSheduleShowroomVisit: typeof commonActions.toggleSheduleShowroomVisit;
  toggleFinancePopUp: typeof commonActions.toggleFinancePopUp;
  toggleServicePopUp: typeof commonActions.toggleServicePopUp;
  financePopupOpen: boolean;
  showroomsList: ShowRoomDetailsModel[];
  vehicleModels: AllVehicleStateModel;
  getVehicleModelsList: typeof allVehicleModelActions.getVehicleModelsList;
  getShowRoomList: typeof showRoomListActions.getShowRoomList;
  requestCallbackPopUpOpen: boolean;
  bookTestDrivePopupOpen: boolean;
  downloadBrochurePopupOpen: boolean;
  sheduleShoroomVisitPopupOpen: boolean;
  appSettingsState: AppSettingsStateViewModel;
  servicePopupOpen: boolean;
  requestQuotePopupOpen: boolean;
}
const Header: React.FunctionComponent<CustomProps> = (props: CustomProps) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { url } = useRouteMatch();
  const [showQiuckForms, setShowQuickForms] = useState(false);
  const { lang } = useParams<{
    lang: string;
  }>();
  const [whatsappPopup, setWhatsappPopup] = React.useState<boolean>(false);
  const handleLanguage = async (lng: string) => {
    if (
      props?.appSettingsState?.data &&
      props?.appSettingsState?.data?.languagesList?.length > 0
    ) {
      const data = props?.appSettingsState?.data?.languagesList.find(
        (item) => item.languageLcidstring === lng
      );
      if (data) {
        await api.setLanguageID(data.languageID);
        await dispatch(AppSettingsLanguageAction(data.languageID));
        await dispatch(
          AppSettingsHtmlDirectionAction(lng === 'en' ? 'ltr' : 'rtl')
        );
        // if(lng)
        const urlSplit = url.split('/');
        if (urlSplit.length > 0 && urlSplit[1] === lang) {
          history.replace({
            pathname: url.replace(lang, lng),
          });
          window.location.reload();
        }
      }
    }
  };
  const [subMenu, OpenSubMenu] = React.useState(false);

  const onTestDrivePopupClick = () => {
    props.toggleBookTestDrive();
    props.toggleMenu();
  };
  const onVisitPopupClick = () => {
    props.toggleSheduleShowroomVisit();
    props.toggleMenu();
  };

  const onCallbackPopupClick = () => {
    props.toggleRequestCallback();
    // props.toggleMenu();
  };

  const onDownloadBrochureClick = () => {
    props.toggleDownloadBrochure();
    props.toggleMenu();
  };

  const onRequestQuoteClick = () => {
    props.toggleRequestQuote();
    props.toggleMenu();
  };

  const onFinancePopupCancel = () => {
    props.toggleFinancePopUp();
  };
  const onFinancePopupClick = () => {
    props.toggleFinancePopUp();
  };
  const onServicePopupClick = () => {
    props.toggleServicePopUp();
  };
  const onServicePopupCancel = () => {
    props.toggleServicePopUp();
  };
  const onRequestQuoteCancel = () => {
    props.toggleRequestQuote();
  };

  const renderBookServiceModal = () => {
    return (
      <ReactModal
        isOpen={props.servicePopupOpen}
        contentLabel="Test Drive"
        style={customStylesPopup}
        onRequestClose={onServicePopupCancel}
        shouldCloseOnOverlayClick={true}
      >
        {/* {props.productData?.productDetails !== undefined && ( */}
        <BookServicePopUp
          onPopupCancel={onServicePopupCancel}
          productID={1}
          showroomsList={props.showroomsList}
          // productDetails={props.productData?.productDetails}
        />
        {/* )} */}
      </ReactModal>
    );
  };

  const renderFinanceModal = () => {
    return (
      <ReactModal
        isOpen={props.financePopupOpen}
        contentLabel="financePopupOpen"
        style={customStylesPopup}
        onRequestClose={onFinancePopupCancel}
        shouldCloseOnOverlayClick={true}
      >
        {/* {props.productData?.productDetails !== undefined && ( */}
        <FinanceCalculatorPopUp
          onPopupCancel={onFinancePopupCancel}
          // productID={1}
          showroomsList={props.showroomsList}
          // productDetails={props.productData?.productDetails}
        />
        {/* )} */}
      </ReactModal>
    );
  };

  const renderRequestQuoteModal = () => {
    return (
      <ReactModal
        isOpen={props.requestQuotePopupOpen}
        contentLabel="Request a Quote"
        style={customStylesPopup}
        onRequestClose={onRequestQuoteCancel}
        shouldCloseOnOverlayClick={true}
      >
        <RequestQuotePopUp
          onPopupCancel={onRequestQuoteCancel}
          showroomsList={props.showroomsList}
          productID={1}
          // productDetails={undefined}
        />
      </ReactModal>
    );
  };

  React.useEffect(() => {
    if (
      props.vehicleModels?.modelsList === undefined ||
      props.vehicleModels?.modelsList?.length === 0
    ) {
      props.getVehicleModelsList();
    }
    if (
      props.showroomsList === undefined ||
      props.showroomsList?.length === 0
    ) {
      props.getShowRoomList();
    }
  }, []);

  const onRequestCallbackClick = () => {
    props.toggleRequestCallback();
  };
  const onRequestCallbackCancel = () => {
    props.toggleRequestCallback();
  };
  const onTestDrivePopupCancel = () => {
    props.toggleBookTestDrive();
  };
  const onDownloadBrochureCancel = () => {
    props.toggleDownloadBrochure();
  };
  const onShowroomVisitPopupClick = () => {
    props.toggleSheduleShowroomVisit();
  };
  const onShowroomVisitPopupCancel = () => {
    props.toggleSheduleShowroomVisit();
  };
  const onFinanceCalculatorClick = () => {
    props.toggleFinancePopUp();
  };

  const renderRequestCallbackModal = () => {
    return (
      <ReactModal
        isOpen={props.requestCallbackPopUpOpen}
        // isOpen={true}
        contentLabel="Request a Callback"
        style={customStylesPopup}
        onRequestClose={() => onRequestCallbackCancel()}
        shouldCloseOnOverlayClick={true}
      >
        <RequestCallbackPopUp
          onPopupCancel={() => onRequestCallbackCancel()}
          showModel={true}
          title={t('header.Request_A_Callback')}
        />
      </ReactModal>
    );
  };

  const renderTestDriveModal = () => {
    return (
      <ReactModal
        isOpen={props.bookTestDrivePopupOpen}
        contentLabel="Test Drive"
        style={customStylesPopup}
        onRequestClose={() => onTestDrivePopupCancel()}
        shouldCloseOnOverlayClick={true}
      >
        <BookTestDrivePopUp
          onPopupCancel={() => onTestDrivePopupCancel()}
          showModel={true}
        />
      </ReactModal>
    );
  };

  const renderDownloadBrochureModal = () => {
    return (
      <ReactModal
        isOpen={props.downloadBrochurePopupOpen}
        // isOpen={true}
        contentLabel="Download Brochure"
        style={customStylesPopup}
        onRequestClose={() => onDownloadBrochureCancel()}
        shouldCloseOnOverlayClick={true}
      >
        <DownloadBrochurePopUp
          onPopupCancel={() => onDownloadBrochureCancel()}
          showModel={true}
          title={'Download brochure'}
        />
      </ReactModal>
    );
  };

  const renderShowroomVisitModal = () => {
    return (
      <ReactModal
        isOpen={props.sheduleShoroomVisitPopupOpen}
        contentLabel="Showroom Visit"
        style={customStylesPopup}
        onRequestClose={() => onShowroomVisitPopupCancel()}
        shouldCloseOnOverlayClick={true}
      >
        <ShowRoomVisitPopUp
          onPopupCancel={() => onShowroomVisitPopupCancel()}
          showModel={true}
        />
      </ReactModal>
    );
  };

  React.useEffect(() => {
    if (history.location?.pathname.includes('build-vehicle')) {
      setShowQuickForms(false);
    } else {
      setShowQuickForms(true);
    }
  }, [history.location]);

  const renderWhatsappModal = () => {
    return (
      <ReactModal
        isOpen={whatsappPopup}
        contentLabel="whatsap chat"
        style={customStylesWhatsappPopup}
        onRequestClose={() => setWhatsappPopup(false)}
        shouldCloseOnOverlayClick={true}
      >
        <div className="d-flex">
          <button
            type="button"
            className="position-absolute right-0 top-0 zIndex-1 font-xl bg-transparent rounded-circle border-0 p-1 m-2 d-inline-block"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => setWhatsappPopup(false)}
          >
            <i className="icon-close text-white"></i>
          </button>
          <a href="tel:1800044" className="d-flex">
            <img
              src={
                lang === 'ar'
                  ? require('assets/images/WhatsApp_Cadillac-AR.png')
                  : require('assets/images/WhatsApp_Cadillac-EN.png')
              }
              width={571}
              height={768}
              className="img-fluid"
            />
          </a>
        </div>
      </ReactModal>
    );
  };

  return (
    <>
      <header
        className={classnames({
          'border-bottom bg-white zIndex-99 d-flex flex-column': true,
          active: props.isMenuOpen,
        })}
      >
        <div className="header-top bg-white border-bottom font-xs order-lg-0 order-last">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 d-flex justify-content-end text-dark flex-lg-row flex-column px-lg-3 px-0">
                <div className="align-items-lg-center d-block d-lg-inline-flex header-top-items p-3 px-lg-4 py-lg-3">
                  {i18n.languages[0] !== 'ar' && (
                    <a
                      href="javascript:void(0)"
                      className="text-dark text-arabic"
                      onClick={() => handleLanguage('ar')}
                    >
                      عربى
                    </a>
                  )}
                  {i18n.languages[0] !== 'en' && (
                    <a
                      href="javascript:void(0)"
                      className="text-dark font-normal"
                      onClick={() => handleLanguage('en')}
                    >
                      English
                    </a>
                  )}
                </div>
                <div className="d-lg-inline-block d-block p-3 header-top-items text-uppercase border-left py-lg-3 px-lg-4 ">
                  <a
                    href="https://www.cadillacalghanim.com/locations/"
                    target="blank"
                    className="mt-lg-1 d-flex align-items-center"
                  >
                    <i className="icon-location-fill mr-2 align-self-center"></i>
                    {t('header.Contact us')}
                  </a>
                </div>
                <div className="d-lg-inline-block d-block p-3 header-top-items text-uppercase border-left py-lg-3 px-lg-4 ">
                  <span className="mt-lg-1 d-inline-flex">
                    <i className="icon-phone mr-2"></i>
                    {t('header.Call')} -
                    <a href="tel:1800044" className="text-dark ml-1">
                      1800044
                    </a>
                  </span>
                </div>
                <div className="d-lg-none d-block text-center font-base p-lg-0 p-3 header-top-items">
                  <a href="#" className="mr-5">
                    <i className="icon-facebook"></i>
                  </a>
                  <a href="#" className="mr-5">
                    <i className="icon-twitter"></i>
                  </a>
                  <a href="#" className="mr-5">
                    <i className="icon-youtube"></i>
                  </a>
                  <a href="#" className="">
                    <i className="icon-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-bottom position-relative">
          <div className="container-fluid">
            <div className="row">
              <div className="col-auto d-flex align-items-center py-1">
                <Link to="/" onClick={() => props.toggleMenu()}>
                  {i18n.languages[0] !== 'ar' && (
                    <img
                      src={require('assets/images/cadillacEn.png')}
                      className="logo"
                      width={101}
                      alt="Cadillac"
                    />
                  )}
                  {i18n.languages[0] === 'ar' && (
                    <img
                      src={require('assets/images/cadillacArbic.png')}
                      className="logo"
                      width={101}
                      alt="Cadillac"
                    />
                  )}
                </Link>
              </div>
              <div className="col-auto ml-auto d-lg-none d-flex align-items-center font-lg">
                <i
                  className="icon-close"
                  onClick={() => props.toggleMenu()}
                ></i>
              </div>
              <div className="col-lg col-12 order-lg-0 order-last d-flex justify-content-end pr-lg-4 px-0 position-static main-menu-outer">
                <ul
                  className={classnames({
                    'list-unstyled d-flex font-normal text-uppercase mb-0 h-100 main-menu bg-white top-0 flex-xl-row flex-column zIndex-9  py-lg-0 py-3':
                      true,
                    active: props.isMenuOpen,
                  })}
                >
                  <li
                    className="d-xl-none d-lg-block d-none text-right"
                    onClick={() => props.toggleMenu()}
                  >
                    <i className="icon-close font-xxl cursor-pointer"></i>
                  </li>
                  <MenuItem
                    externalLink={`${
                      lang === 'en'
                        ? 'https://www.cadillacalghanim.com/new-vehicles/'
                        : 'https://ar.cadillacalghanim.com/new-vehicles/'
                    }`}
                    title={t('header.New Vehicles')}
                    target="blank"
                  />

                  <MenuItem
                    submenu
                    title={t('header.Buy Online')}
                    className={subMenu ? 'active' : ''}
                    onClick={() => OpenSubMenu(!subMenu)}
                  >
                    <div className="mega-menu bg-white w-100 position-absolute align-x-center shadow d-flex flex-wrap justify-content-center font-normal pt-xl-0 pt-3">
                      <div className="col-xl-4 col-12 mega-menu-block px-0">
                        <ul className="list-unstyled mb-0">
                          <li className="p-0 border-bottom">
                            <Link
                              to={`/${lang}/`}
                              className="d-inline-flex align-items-center p-3 w-100"
                              onClick={() => props.toggleMenu()}
                            >
                              <i className="icon-build-price mr-2 submenu-icon text-center font-xxl"></i>
                              {t('header.Buy Online')}
                            </Link>
                          </li>
                          {/* <li className="p-0 border-bottom">
                            <Link
                              to="#"
                              onClick={() => props.toggleMenu()}
                              className="d-inline-flex align-items-center p-3 w-100"
                            >
                              <i className="icon-search-inventory mr-2 submenu-icon text-center font-xxl"></i>
                              Search Inventory
                            </Link>
                          </li> */}
                          <li className="p-0 border-bottom">
                            <a
                              target="blank"
                              href={`${
                                lang === 'en'
                                  ? 'https://www.cadillacalghanim.com/new-vehicle-offers/'
                                  : 'https://ar.cadillacalghanim.com/new-vehicle-offers/'
                              }`}
                              onClick={() => props.toggleMenu()}
                              className="d-inline-flex align-items-center p-3 w-100"
                            >
                              <i className="icon-special-offers mr-2 submenu-icon text-center font-xxl"></i>
                              {t('header.Special Offers')}
                            </a>
                          </li>
                          <li className="p-0">
                            <a
                              href="javascript:void(0);"
                              onClick={() => {
                                onFinancePopupClick();
                                props.toggleMenu();
                              }}
                              className="d-inline-flex align-items-center p-3 w-100"
                            >
                              <i className="icon-estimate-payment mr-2 submenu-icon text-center font-xxl"></i>
                              {t('header.Estimate a Payment')}
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-xl-4 col-12 py-4 mega-menu-block">
                        <ul className="list-unstyled mb-0">
                          <li>
                            <span className="mb-4 d-inline-block">
                              {t('header.MORE SHOPPING TOOLS')}
                            </span>
                            <ul className="list-unstyled mb-0 font-weight-normal text-capitalize">
                              <li className="px-0">
                                <Link
                                  to="#"
                                  onClick={() => {
                                    onCallbackPopupClick();
                                    props.toggleMenu();
                                  }}
                                  className="d-inline-flex align-items-center mb-3"
                                >
                                  <i className="icon-chevron-right mr-2 font-xxxs"></i>
                                  {t('common.Request a Call Back')}
                                </Link>
                              </li>
                              <li className="px-0">
                                <Link
                                  to="#"
                                  onClick={() => {
                                    onTestDrivePopupClick();
                                    props.toggleMenu();
                                  }}
                                  className="d-inline-flex align-items-center mb-3"
                                >
                                  <i className="icon-chevron-right mr-2 font-xxxs"></i>
                                  {t('header.Test Drive')}
                                </Link>
                              </li>
                              <li className="px-0">
                                <Link
                                  to="#"
                                  onClick={() => {
                                    onDownloadBrochureClick();
                                    props.toggleMenu();
                                  }}
                                  className="d-inline-flex align-items-center mb-3"
                                >
                                  <i className="icon-chevron-right mr-2 font-xxxs"></i>
                                  {t('common.Download Brochure')}
                                </Link>
                              </li>
                              <li className="px-0">
                                <Link
                                  to="#"
                                  onClick={() => {
                                    onShowroomVisitPopupClick();
                                    props.toggleMenu();
                                  }}
                                  className="d-inline-flex align-items-center mb-3"
                                >
                                  <i className="icon-chevron-right mr-2 font-xxxs"></i>
                                  {t('common.Schedule a Showroom Visit')}
                                </Link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                      <div className="col-xl-4 col-12 py-4 mega-menu-block border-left-0">
                        <ul className="list-unstyled mb-0">
                          <li>
                            <span className="mb-4 d-inline-block">
                              {t('header.PURCHASE TOOLS')}
                            </span>
                            <ul className="list-unstyled mb-0 font-weight-normal text-capitalize">
                              {/* <li className="px-0">
                                <Link
                                  to="#"
                                  onClick={() => props.toggleMenu()}
                                  className="d-inline-flex align-items-center mb-3"
                                >
                                  <i className="icon-chevron-right mr-2 font-xxxs"></i>
                                  Trade In Value
                                </Link>
                              </li> */}
                              <li className="px-0">
                                <a
                                  target="blank"
                                  href={
                                    'https://www.cadillacalghanim.com/finance-offers/financing/'
                                  }
                                  onClick={() => props.toggleMenu()}
                                  className="d-inline-flex align-items-center mb-3"
                                >
                                  <i className="icon-chevron-right mr-2 font-xxxs"></i>
                                  {t('header.Finance Options')}
                                </a>
                              </li>
                              {/* <li className="px-0">
                                <Link
                                  to="#"
                                  onClick={() => props.toggleMenu()}
                                  className="d-inline-flex align-items-center mb-3"
                                >
                                  <i className="icon-chevron-right mr-2 font-xxxs"></i>
                                  Insurance
                                </Link>
                              </li> */}

                              <li className="px-0">
                                <a
                                  target="blank"
                                  href={`${
                                    lang === 'en'
                                      ? 'https://www.cadillacalghanim.com/owners/premium-care-plus/'
                                      : 'https://ar.cadillacalghanim.com/owners/premium-care-plus/warranty/'
                                  }`}
                                  onClick={() => props.toggleMenu()}
                                  className="d-inline-flex align-items-center mb-3"
                                >
                                  <i className="icon-chevron-right mr-2 font-xxxs"></i>
                                  {t('header.Vehicle Protection')}
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </MenuItem>
                  <MenuItem
                    externalLink={`${
                      lang === 'en'
                        ? 'https://www.cadillacalghanim.com/new-vehicle-offers/'
                        : 'https://ar.cadillacalghanim.com/new-vehicle-offers/'
                    }`}
                    title={t('header.Secret Offers')}
                    target="blank"
                  />

                  <MenuItem
                    externalLink={`${
                      lang === 'en'
                        ? 'https://www.cadillacalghanim.com/news/'
                        : 'https://ar.cadillacalghanim.com/news/'
                    }`}
                    title={t('header.News')}
                    target="blank"
                  />
                  <MenuItem
                    externalLink={`${
                      lang === 'en'
                        ? 'https://www.cadillacalghanim.com/owners/'
                        : 'https://ar.cadillacalghanim.com/owners/'
                    }`}
                    title={t('header.Owners')}
                    target="blank"
                  />
                  <MenuItem
                    externalLink={`${
                      lang === 'en'
                        ? 'https://www.cadillacalghanim.com/locations/'
                        : 'https://ar.cadillacalghanim.com/locations/'
                    }`}
                    title={t('header.Locations')}
                    target="blank"
                  />
                  <MenuItem
                    Link={`/${lang}${RouteKeys.MyAccount}`}
                    title={t('header.My Cadillac')}
                    target="blank"
                  />
                </ul>
              </div>
              <div className="col-12 d-lg-none border-top border-bottom quick-links py-3 d-flex text-nowrap overflow-auto">
                {/* <div className="d-inline-block text-center mr-1 pr-3">
                  <Link to="#" onClick={() => props.toggleMenu()}>
                    <div className="quick-link-icon text-primary rounded font-md d-inline-flex justify-content-center align-items-center mb-1">
                      <i className="icon-chat"></i>
                    </div>
                    <p className="mb-0 text-muted">Live Chat</p>
                  </Link>
                </div> */}
                <div className="d-inline-block text-center mr-1 pr-3">
                  <a
                    onClick={() => {
                      onCallbackPopupClick();
                      props.toggleMenu();
                    }}
                  >
                    <div className="quick-link-icon text-primary rounded font-md d-inline-flex justify-content-center align-items-center mb-1">
                      <i className="icon-callback"></i>
                    </div>
                    <p className="mb-0 text-muted">
                      {t('header.Request a')}
                      <br />
                      {t('header.Callback')}
                    </p>
                  </a>
                </div>
                <div className="d-inline-block text-center mr-1 pr-3">
                  <a
                    onClick={() => {
                      onTestDrivePopupClick();
                      props.toggleMenu();
                    }}
                  >
                    <div className="quick-link-icon text-primary rounded font-md d-inline-flex justify-content-center align-items-center mb-1">
                      <i className="icon-test-drive"></i>
                    </div>
                    <p className="mb-0 text-muted">
                      {t('header.Book a')}
                      <br />
                      {t('header.Test Drive')}
                    </p>
                  </a>
                </div>
                <div className="d-inline-block text-center mr-1 pr-3">
                  <a
                    onClick={() => {
                      onDownloadBrochureClick();
                      props.toggleMenu();
                    }}
                  >
                    <div className="quick-link-icon text-primary rounded font-md d-inline-flex justify-content-center align-items-center mb-1">
                      <i className="icon-download"></i>
                    </div>
                    <p className="mb-0 text-muted">
                      {t('header.Download')}
                      <br />
                      {t('header.Brochure')}
                    </p>
                  </a>
                </div>
                {/* <div className="d-inline-block text-center mr-1 pr-3">
                  <a onClick={() => { onRequestQuoteClick(); props.toggleMenu(); }}>
                    <div className="quick-link-icon text-primary rounded font-md d-inline-flex justify-content-center align-items-center mb-1">
                      <i className="icon-quote"></i>
                    </div>
                    <p className="mb-0 text-muted">
                      Request a<br />
                      Quote
                    </p>
                  </a>
                </div> */}
                <div className="d-inline-block text-center mr-1 pr-3">
                  <a
                    onClick={() => {
                      onVisitPopupClick();
                      props.toggleMenu();
                    }}
                  >
                    <div className="quick-link-icon text-primary rounded font-md d-inline-flex justify-content-center align-items-center mb-1">
                      <i className="icon-schedule"></i>
                    </div>
                    <p className="mb-0 text-muted">
                      {t('header.Schedule a')}
                      <br />
                      {t('header.Showroom Visit')}
                    </p>
                  </a>
                </div>
              </div>
              <div className="col-auto d-xl-none d-lg-flex d-none align-items-center">
                <i
                  className="icon-menu icon-flip-rtl"
                  onClick={() => props.toggleMenu()}
                ></i>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="quick-links position-fixed right-0 align-y-center bg-white">
        <ul className="list-unstyled mb-0 p-0 font-weight-semibold font-md">
          <li className="border-bottom">
            <a
              className="d-flex align-items-center"
              onClick={() => {
                onRequestQuoteClick();
              }}
            >
              <i className="icon-quote font-xxl text-gray-800 text-center"></i>
              <span className="text-gray-900 d-lg-inline-block d-none">
                {t('header.Request a Quote')}
              </span>
            </a>
          </li>
          <li className="border-bottom">
            <a
              className="d-flex align-items-center"
              onClick={() => {
                onTestDrivePopupClick();
              }}
            >
              <i className="icon-test-drive font-xxl text-gray-800 text-center"></i>
              <span className="text-gray-900 d-lg-inline-block d-none">
                {t('header.Request a Test Drive')}
              </span>
            </a>
          </li>
          <li className="border-bottom">
            <a
              className="d-flex align-items-center"
              onClick={() => {
                onServicePopupClick();
              }}
            >
              <i className="icon-book-service font-xxl text-gray-800 text-center"></i>
              <span className="text-gray-900 d-lg-inline-block d-none">
                {t('header.Book Service Appointment')}
              </span>
            </a>
          </li>
          <li className="border-bottom">
            <a
              href="javascript:void(0);"
              onClick={() => {
                onFinanceCalculatorClick();
              }}
              className="d-flex align-items-center"
            >
              <i className="icon-financial-calculator font-xxl text-gray-800 text-center"></i>
              <span className="text-gray-900 d-lg-inline-block d-none">
                {t('header.Financial Calculator')}
              </span>
            </a>
          </li>
          <li className="border-bottom">
            <a
              // onClick={() => setWhatsappPopup(true)}
              href={`https://api.whatsapp.com/send/?phone=${Config.WHATSAPP_NO}`}
              target="blank"
              className="d-flex align-items-center"
            >
              <i className="icon-whatsapp font-xxl text-gray-800 text-center"></i>
              <span className="text-gray-900 d-lg-inline-block d-none">
                {t('header.Whatsapp Us')}
              </span>
            </a>
          </li>
          <li className="border-bottom">
            <a href="tel:+965 1800044" className="d-flex align-items-center">
              <i className="icon-call font-xxl text-gray-800 text-center"></i>
              <span className="text-gray-900 d-lg-inline-block d-none">
                {t('header.Contact Us')}
              </span>
            </a>
          </li>
          <li className="">
            <a
              className="d-flex align-items-center"
              target="blank"
              href="https://www.cadillacalghanim.com/locations/"
            >
              <i className="icon-loc-pointer font-xxl text-gray-800 text-center"></i>
              <span className="text-gray-900 d-lg-inline-block d-none">
                {t('header.Locate Us')}
              </span>
            </a>
          </li>
        </ul>
      </div>
      {showQiuckForms && (
        <>
          {renderFinanceModal()}
          {renderRequestCallbackModal()}
          {renderTestDriveModal()}
          {renderDownloadBrochureModal()}
          {renderShowroomVisitModal()}
          {renderBookServiceModal()}
          {renderRequestQuoteModal()}
          {renderWhatsappModal()}
        </>
      )}
    </>
  );
};

const mapActionsToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      dispatch,
      toggleMenu: commonActions.toggleMenu,
      toggleRequestCallback: commonActions.toggleRequestCallback,
      toggleBookTestDrive: commonActions.toggleBookTestDrive,
      toggleDownloadBrochure: commonActions.toggleDownloadBrochure,
      toggleRequestQuote: commonActions.toggleRequestQuote,
      toggleSheduleShowroomVisit: commonActions.toggleSheduleShowroomVisit,
      toggleFinancePopUp: commonActions.toggleFinancePopUp,
      getVehicleModelsList: allVehicleModelActions.getVehicleModelsList,
      getShowRoomList: showRoomListActions.getShowRoomList,
      toggleServicePopUp: commonActions.toggleServicePopUp,
    },
    dispatch
  );
};

const mapStateToProps = (state: State) => {
  return {
    isMenuOpen: state.commonState.headerMenuOpen,
    financePopupOpen: state.commonState.financePopupOpen,
    showroomsList: state.showRoomState.showroomsList,
    vehicleModels: state.allVehicleState,
    requestCallbackPopUpOpen: state.commonState.requestCallbackPopUpOpen,
    bookTestDrivePopupOpen: state.commonState.bookTestDrivePopupOpen,
    downloadBrochurePopupOpen: state.commonState.downloadBrochurePopupOpen,
    sheduleShoroomVisitPopupOpen:
      state.commonState.sheduleShoroomVisitPopupOpen,
    appSettingsState: state.appSettingsState,
    servicePopupOpen: state.commonState.servicePopupOpen,
    requestQuotePopupOpen: state.commonState.requestQuotePopupOpen,
  };
};

export default connect(mapStateToProps, mapActionsToProps)(Header);
